import { colors } from '@lmc/common/constants'
import type React from 'react'
import type { CSSProperties } from 'react'
import styled from 'styled-components'
import IconType from '../../../general/Icon/iconTypes'
import Icon from '../../../general/Icon/index'

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`

const LogoIcon = styled(Icon)`
  margin-left: 20px;
  width: 26px;
  height: 24px;
`

const LogoTextIcon = styled(Icon)<{ $type: 'light' | 'dark' }>`
  margin-right: 50px;
  margin-left: 5px;
  margin-top: 2px;
  width: 85px;
  height: 15px;
  fill: ${({ theme, $type }) =>
    $type === 'light'
      ? theme.color.neutral.color11
      : theme.color.background.primary};
`

export interface LogoProps {
  type: 'light' | 'dark'
  style?: CSSProperties
}

export const Logo: React.FC<LogoProps> = ({ type }) => {
  return (
    <LogoWrapper>
      <LogoIcon customIcon={IconType.NewLogo} />
      <LogoTextIcon customIcon={IconType.NewLogoText} $type={type} />
    </LogoWrapper>
  )
}
